import { patientApi } from '@/api/PatientApi'
import type {
	PatientBillingPrimaryCard,
	PatientBillingRecord,
} from '@/api/types/PatientApi'
import { useMutation, useQueryClient } from '@tanstack/react-query'

const useUpdatePrimaryCard = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ({ token }: { token: string }) => patientApi.updatePrimaryCard({ token }),
		onSuccess: (primaryCard: PatientBillingPrimaryCard | null) => {
			// Show the new default card immediately from the write-through response, then refetch
			// as a backstop so the record stays consistent with the server.
			if (primaryCard) {
				queryClient.setQueryData(['patient-billing'], (old?: PatientBillingRecord) =>
					old ? { ...old, primaryCard } : old
				)
			}
			queryClient.invalidateQueries({
				queryKey: ['patient-billing'],
			})
		},
	})
}

export { useUpdatePrimaryCard }
